export const FETCH_NBR_LIST = 'FETCH_NBR_LIST';
export const SET_LIST = 'SET_LIST';
export const FETCH_NBR_STATS = 'FETCH_NBR_STATS';
